import { RENDICION_API_URL } from "@/config";
import axios from "axios";

export const api_rendicion = axios.create({
  baseURL: RENDICION_API_URL,
});
